// @flow
import React, { useMemo } from "react";
import TrustPilotLogo from "../TrustPilotLogo";
import TrustPilotStars from "../TrustPilotStars";
import Typography from "../Typography";

import styles from "./trustPilotRating.module.scss";

type Props = {
  subtext: string,
  rating: number,
  isFlat?: boolean,
  isCompact?: boolean,
  isLight?: boolean
};

/**
 * A 4.8 rating or higher is shown as five full stars on the trustpilot UI
 */
const TrustPilotRating = ({
  subtext,
  rating,
  isFlat = false,
  isCompact = false,
  isLight = false
}: Props) => {
  const starRating = useMemo(() => {
    const value = parseFloat(rating);

    if (value >= 4.8) {
      return "5";
    }

    if (value >= 4.3) {
      return "4.5";
    }

    return "4";
  }, [rating]);

  const flatStyles = isFlat ? styles.flat : "";
  const compactStyles = isCompact ? styles.compact : "";

  return (
    <div className={`${flatStyles} ${compactStyles}`}>
      <div className={styles.row}>
        <TrustPilotLogo className={styles.logo} isLight={isLight} />

        <div className={styles.stars}>
          <TrustPilotStars rating={starRating} />
        </div>
      </div>
      <Typography
        size="secondary"
        bold
        className={`${styles.text} ${isLight ? styles.lightText : ""}`}
      >
        {subtext}
      </Typography>
    </div>
  );
};

export default TrustPilotRating;
